import PageHeader from "@/components/PageHeader";
import Pony from "@/components/Pony";

export default function PonyPage() {
  return (
    <>
      <PageHeader
        overline="Mofa Pony"
        title="Der Kult"
        accent="lebt weiter."
        subtitle="Pony GTX und Pony Cross — Schweizer Kult-Mofas in zeitloser Qualität. Robust, einfach, ehrlich."
      />
      <Pony />
    </>
  );
}
